import qs from 'qs'

export default {
  defaultPageSize: 10,
  maxPageSize: 100,
  itemsPerPageOptions: [10, 25, 50, 100],
  genderOptions: [
    {
      text: 'Male',
      value: 'M',
    },
    {
      text: 'Female',
      value: 'F',
    },
  ],
  studentStatusOptions: [
    {
      text: 'Active',
      value: 'ACTIVE',
      color: 'primary',
    },
    {
      text: 'Inactive',
      value: 'INACTIVE',
      color: 'grey',
    },
  ],
  teacherStatusOptions: [
    {
      text: 'Active',
      value: 'ACTIVE',
      color: 'primary',
    },
    {
      text: 'Inactive',
      value: 'INACTIVE',
      color: 'grey',
    },
  ],
  lessonPlanStatusOptions: [
    {
      text: 'Active',
      value: 'ACTIVE',
      color: 'primary',
    },
    {
      text: 'Inactive',
      value: 'INACTIVE',
      color: 'grey',
    },
  ],
  lessonCategories: [
    {
      text: 'Reading',
      value: 'READING',
    },
    {
      text: 'Listening',
      value: 'LISTENING',
    },
    {
      text: 'Speaking',
      value: 'SPEAKING',
    },
    {
      text: 'Writing',
      value: 'WRITING',
    },
    {
      text: 'Learn and Sing',
      value: 'LEARN_AND_SING',
    },
    {
      text: 'Misc',
      value: 'MISC',
    },
  ],
  yesNoOptions: [
    {
      text: 'Yes',
      value: 1,
    },
    {
      text: 'No',
      value: 0,
    },
  ],
  classroomTypeOptions: [
    {
      text: 'Private',
      value: 'PRIVATE',
    },
    {
      text: 'Small Group',
      value: 'SMALL_GROUP',
    },
    {
      text: 'Large Group',
      value: 'LARGE_GROUP',
    },
    {
      text: 'Group 2',
      value: 'GROUP_2',
    },
    {
      text: 'Group 3',
      value: 'GROUP_3',
    },
    {
      text: 'Group 4',
      value: 'GROUP_4',
    },
    {
      text: 'Group 5',
      value: 'GROUP_5',
    },
    {
      text: 'Group 6',
      value: 'GROUP_6',
    },
  ],
  subscriptionPackageStatusOptions: [
    {
      text: 'Active',
      value: 'ACTIVE',
      color: 'primary',
    },
    {
      text: 'Inactive',
      value: 'INACTIVE',
      color: 'grey',
    },
  ],
  subscriptionOrderStatusOptions: [
    {
      text: 'Inactive',
      value: 'INACTIVE',
      color: 'grey',
    },
    {
      text: 'Active',
      value: 'ACTIVE',
      color: 'primary',
    },
    {
      text: 'Canceled',
      value: 'CANCELED',
      color: 'error',
    },
    {
      text: 'Done',
      value: 'DONE',
      color: 'success',
    },
  ],
  invoiceStatusOptions: [
    {
      text: 'Pending',
      value: 'PENDING',
      color: 'grey',
    },
    {
      text: 'Sent & In Progress',
      value: 'IN_PROGRESS',
      color: 'warning',
    },
    {
      text: 'Paid',
      value: 'PAID',
      color: 'success',
    },
    {
      text: 'Canceled',
      value: 'CANCELED',
      color: 'error',
    },
  ],
  depositOptions: [
    {
      text: 'Exist',
      value: 'YES',
      color: 'success',
    },
    {
      text: 'Not Exist',
      value: 'NO',
      color: 'grey',
    },
  ],
  dayOfWeekOptions: [
    {
      text: 'Monday',
      value: 1,
    },
    {
      text: 'Tuesday',
      value: 2,
    },
    {
      text: 'Wednesday',
      value: 3,
    },
    {
      text: 'Thursday',
      value: 4,
    },
    {
      text: 'Friday',
      value: 5,
    },
    {
      text: 'Saturday',
      value: 6,
    },
    {
      text: 'Sunday',
      value: 7,
    },
  ],
  payrollStatusOptions: [
    {
      text: 'Pending',
      value: 'PENDING',
      color: 'grey',
    },
    {
      text: 'Processed',
      value: 'IN_PROGRESS',
      color: 'warning',
    },
    {
      text: 'Paid',
      value: 'PAID',
      color: 'success',
    },
    {
      text: 'Canceled',
      value: 'CANCELED',
      color: 'error',
    },
  ],
  classroomStatusOptions: [
    {
      text: 'Inactive',
      value: 'INACTIVE',
      color: 'grey',
    },
    {
      text: 'Active',
      value: 'ACTIVE',
      color: 'primary',
    },
    {
      text: 'Ended',
      value: 'ENDED',
      color: 'success',
    },
  ],
  scoreGradeOptions: [
    {
      text: 'A',
      value: 100,
      color: 'success',
    },
    {
      text: 'B',
      value: 75,
      color: 'secondary',
    },
    {
      text: 'C',
      value: 50,
      color: 'error',
    },
    {
      text: 'N/A',
      value: 0,
      color: 'disabled',
    },
  ],
  gameLevelOptions: [
    {
      text: 'No Access',
      value: 0,
    },
    {
      text: 'Level 1',
      value: 1,
    },
    {
      text: 'Level 2',
      value: 2,
    },
    {
      text: 'Level 3',
      value: 3,
    },
  ],
  holidayStatusOptions: [
    {
      text: 'Inactive',
      value: 'INACTIVE',
      color: 'grey',
    },
    {
      text: 'Active',
      value: 'ACTIVE',
      color: 'primary',
    },
  ],
  rowsPerPageOptions: [10, 25, 50, 100],
  waContactUrl: process.env.MIX_WA_CONTACT_URL,
  waRegisterUrl:
    process.env.MIX_WA_CONTACT_URL +
    qs.stringify(
      {
        text: 'Saya ingin mendaftar di XuYuan Class',
      },
      { addQueryPrefix: true }
    ),
  waPromoUrl:
    process.env.MIX_WA_CONTACT_URL +
    qs.stringify(
      {
        text: 'Hai, saya mau tanya info detail untuk promo bulan ini',
      },
      { addQueryPrefix: true }
    ),
}
